<template>
	<v-container
		class=" pa-2 normal-font main-outer-container"
		pa-0
		d-flex
		justify-center
		full-width
	>
		<v-layout justify-center column style="max-width: 600px">
			<v-flex
				class="total-commission"
				:style="{ backgroundColor: themeInputColor }"
				pa-4
			>
				<div class="mb-4">
					*CAC LTV benefits will be credited once per device
				</div>
				<div class="big-font">Total Commission</div>
				<div class="huge-font">
					<span class="bigger-font half-opacity">&#8377;</span>
					{{ rewardHistory.totalRewardCommission }}
				</div>
			</v-flex>
			<v-layout column class="user-list-container">
				<v-layout row justify-space-between class="user-list-header">
					<div>Users</div>
					<div class="progress-line">Progress</div>
				</v-layout>
				<v-layout column class="user-list-content">
					<v-flex
						v-for="(user, index) in rewardHistory.customers"
						:key="index"
						class="no-text-dec list__tile--link mb-2"
						align-center
						@click="setJeet11UserProfile(user)"
					>
						<router-link
							:to="{
								name: 'user-profile',
								params: { appType: appType }
							}"
							:key="index"
							:class="
								`no-text-dec full-width ${
									!isTimeRemaining(user) ? 'half-opacity' : ''
								}`
							"
							tag="button"
							:disabled="!isTimeRemaining(user)"
						>
							<div class="user-card">
								<div class="user-details-container">
									<div class="user-details-content">
										<div class="big-font">
											{{ user.teamName }}
										</div>
										<div>
											&#8377;
											{{
												user.rewardStatus.rewardLevels
													.totalRewardClaimed
											}}
										</div>
									</div>
									<div class="user-details-content">
										<div
											v-if="
												Math.floor(
													user.rewardStatus
														.rewardLevels
														.totalRewardClaimed /
														user.rewardStatus
															.rewardLevels
															.totalReward
												) ||
													!user.rewardStatus
														.expiryStatus.isEligible
											"
										>
											No more rewards left
										</div>
										<div v-else>
											{{ getTimeRemaining(user) }}
										</div>
										<div>Com. earned</div>
									</div>
								</div>
								<div class="user-details-progress">
									<v-icon
										v-if="
											Math.floor(
												user.rewardStatus.rewardLevels
													.totalRewardClaimed /
													user.rewardStatus
														.rewardLevels
														.totalReward
											)
										"
										size="40px"
										color="success"
										>check_circle</v-icon
									>
									<v-progress-circular
										v-else
										:value="
											(user.rewardStatus.rewardLevels
												.totalRewardClaimed *
												100) /
												user.rewardStatus.rewardLevels
													.totalReward
										"
										color="#0A8DD3"
										rotate="-90"
										size="40"
									></v-progress-circular>
								</div>
							</div>
						</router-link>
					</v-flex>
				</v-layout>
			</v-layout>
			<v-layout row wrap class="justify-center my-3 px-2 pb-2">
				<div>
					<v-btn
						:color="themeInputColor"
						dark
						v-if="rewardHistory.offset"
						@click.stop="
							fetchJeet11PartnerRechargeHistory({
								type: END,
								rewardHistory: true
							})
						"
						:loading="fetchingRechargeHistory"
						>Load More</v-btn
					>
				</div>
			</v-layout>
		</v-layout>
	</v-container>
</template>

<script>
import {
	SET_JEET11_USER_PROFILE,
	FETCH_JEET11_PARTNER_RECHARGE_HISTORY,
	RESET_JEET11_PARTNER_RECHARGE_HISTORY
} from "@/store/action-types";
import { TOP } from "@/store/config";
import { THEME_INPUT_COLOUR, RUMMY_COLOUR } from "@/components/constants";
import { mapState } from "vuex";
import EventsManager from "@/event-manager";
export default {
	props: ["appType"],
	data() {
		return {
			fetchingRechargeHistory: false
		};
	},
	mounted() {
		this.fetchJeet11PartnerRechargeHistory({
			type: TOP,
			rewardHistory: true
		});
		EventsManager.sendEvent({
			name: "REWARD_SECTION_VISITED"
		});
	},
	computed: {
		...mapState({
			rewardHistory: state =>
				state.jeet11.jeet11PartnerRechargeHistory.rewardHistory
		}),
		themeInputColor() {
			return this.appType === "RUMMY" ? RUMMY_COLOUR : THEME_INPUT_COLOUR;
		}
	},
	methods: {
		duration(date1, date2) {
			if (date2 < date1) return "Time's up";
			let delta = (date2 - date1) / 1000;
			const days = Math.floor(delta / 86400);
			return days + " days left ";
		},
		getTimeRemaining(user) {
			if (user.rewardStatus.expiryStatus.isEligible) {
				const expiryDate = new Date(
					user.rewardStatus.expiryStatus.expiryDate
				);
				const today = new Date();
				return this.duration(today, expiryDate);
			} else {
				return null;
			}
		},
		setJeet11UserProfile(user) {
			this.$store.dispatch(SET_JEET11_USER_PROFILE.dispatch, user);
		},
		isTimeRemaining(user) {
			if (user.rewardStatus.expiryStatus.isEligible) {
				const expiryDate = new Date(
					user.rewardStatus.expiryStatus.expiryDate
				);
				const today = new Date();
				return expiryDate > today;
			} else return 1;
		},
		fetchJeet11PartnerRechargeHistory(payload) {
			if (!this.fetchingRechargeHistory) {
				this.fetchingRechargeHistory = true;
				this.$store
					.dispatch(FETCH_JEET11_PARTNER_RECHARGE_HISTORY.dispatch, {
						...payload,
						appName: this.appType
					})
					.catch(() => {})
					.then(() => {
						this.fetchingRechargeHistory = false;
					});
			}
		}
	},
	watch: {
		appType() {
			this.$store.dispatch(
				RESET_JEET11_PARTNER_RECHARGE_HISTORY.dispatch
			);
			this.fetchJeet11PartnerRechargeHistory({
				type: TOP,
				rewardHistory: true
			});
		}
	}
};
</script>

<style scoped lang="scss">
button:focus {
	outline: none;
}
.normal-font {
	font-size: 12px;
	font-weight: 400;
}
.big-font {
	font-size: 14px;
	font-weight: 500;
}
.bigger-font {
	font-size: 24px;
	font-weight: 500;
}
.huge-font {
	font-size: 30px;
	font-weight: 500;
}
.half-opacity {
	opacity: 0.6;
}
@media (min-width: 600px) {
	.normal-font {
		font-size: 16px;
	}
	.big-font {
		font-size: 18px;
	}
}
.total-commission {
	color: #f1f2f4;
	border-radius: 4px;
}
.user-list-container {
	.user-list-header {
		margin: 18px 8px 10px 8px;
		color: #7b899e;
	}
	.user-list-content {
		.user-card {
			padding: 8px;
			background-color: #e7e9ec;
			border-radius: 4px;
			color: #2d4970;
			display: flex;
			.user-details-container {
				display: flex;
				flex-direction: column;
				flex: 1 1 auto;
				.user-details-content {
					margin: 2px 0;
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;
				}
			}
			.user-details-progress {
				display: flex;
				align-items: center;
				margin-left: 8px;
			}
		}
	}
}
</style>
